import { Suspense, useEffect } from "react";
import { useQueryLoader } from "react-relay";

import { Loader } from "@whoosh/design-system/src/components/display";

import {
  JoinBookingModalInner,
  JoinBookingModalInnerQueryString,
} from "./JoinBookingModalInner";
import { JoinBookingModalInnerQuery } from "./__generated__/JoinBookingModalInnerQuery.graphql";

type JoinBookingModalProps = {
  isOpen: boolean;
  onClose: () => void;
  slotId: string;
  onRowPress: (slotId: string) => void;
  isWaitlistBooking: boolean;
};

export const JoinBookingModal = ({
  isOpen,
  onClose,
  slotId,
  onRowPress,
  isWaitlistBooking,
}: JoinBookingModalProps) => {
  const [queryRef, loadQuery] = useQueryLoader<JoinBookingModalInnerQuery>(
    JoinBookingModalInnerQueryString
  );

  useEffect(() => {
    if (slotId) {
      loadQuery(
        {
          slotId,
        },
        { fetchPolicy: "store-and-network" }
      );
    }
  }, [loadQuery, slotId]);

  return queryRef ? (
    <Suspense fallback={<Loader />}>
      {queryRef ? (
        <JoinBookingModalInner
          queryRef={queryRef}
          onClose={onClose}
          isOpen={isOpen}
          onRowPress={onRowPress}
          isWaitlistBooking={isWaitlistBooking}
        />
      ) : null}
    </Suspense>
  ) : null;
};
